export default {
  authenticated: false,
  role: 2,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/state.js